module.exports = __webpack_public_path__ + "static/media/calendar.2fca34b9.svg";